import { resolveMediaUrl } from './mediaUrl';

const parseMarketCaption = (caption) => {
  if (!caption) {
    return { name: '', items: '', linkUrl: '' };
  }

  try {
    const parsed = JSON.parse(caption);
    return {
      name: parsed.name || '',
      items: parsed.items || '',
      linkUrl: parsed.linkUrl || '',
    };
  } catch {
    return { name: '', items: '', linkUrl: '' };
  }
};

export const parseHomeGlobalMarketsContent = (page) => {
  if (!page?.sections?.length) {
    return null;
  }

  const section = page.sections.find((item) => item.key === 'global-markets');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  const marketMedia = section.media?.groups?.markets || [];

  if (!fields.eyebrow || !fields.title || !fields.lead || marketMedia.length === 0) {
    return null;
  }

  const markets = marketMedia
    .map((item) => {
      const parsed = parseMarketCaption(item.caption);
      if (!parsed.name || !item.url) {
        return null;
      }

      return {
        name: parsed.name,
        items: parsed.items || '',
        icon: resolveMediaUrl(item.url),
        to: parsed.linkUrl || '#',
      };
    })
    .filter(Boolean);

  if (markets.length === 0) {
    return null;
  }

  return {
    eyebrow: fields.eyebrow,
    title: fields.title,
    lead: fields.lead,
    markets,
  };
};
